import React from 'react'
import { moduleContext } from 'react-contextual'
import { useSelector } from 'react-redux'
import { walletApiSelectors } from 'modules/api/wallet'

interface ConsolidatedBalanceProviderProps {
  customerId: string
}

const ConsolidatedBalanceProvider = moduleContext()(
  ({
    context,
    children,
    customerId,
  }: ConsolidatedBalanceProviderProps & { context: any; children: React.ReactNode }) => {
    const store = {
      balance: useSelector(state => walletApiSelectors.getConsolidatedBalance(state)(customerId)),
    }

    return <context.Provider value={store}>{children}</context.Provider>
  },
)

export default ConsolidatedBalanceProvider
